import { apiServerRoutes } from '../constants/apiRoutes'
import { DEVICE_TYPE } from '../constants/general'
import { getAPICallServer, postAPICallServer } from '../utils/axios.util'

class UserService {
  save(req: any) {
    return postAPICallServer(apiServerRoutes.USER_CONFIG_SAVE, req.body, req)
  }
  fetch(req: any) {
    return getAPICallServer(apiServerRoutes.USER_CONFIG_FETCH, req)
  }
  checkAvailibilty(req: any) {
    console.log(apiServerRoutes.CHECK_AVAILABILITY)
    return postAPICallServer(apiServerRoutes.CHECK_AVAILABILITY, req.body, req)
  }
  sendOtpForVerification(req: any) {
    return postAPICallServer(apiServerRoutes.OTP_VERIFICATION, req.body, req)
  }
  async verifyOtp(req: any) {
    const fcmPayload = {
      device_type: DEVICE_TYPE,
      device_token: req.body.FCMToken,
    }
    return postAPICallServer(
      apiServerRoutes.VERIFY_OTP,
      { ...req.body, ...fcmPayload },
      req,
    )
  }
  getProfile(req: any) {
    return getAPICallServer(apiServerRoutes.GET_PROFILE, req)
  }
  updateProfile(req: any) {
    return postAPICallServer(apiServerRoutes.UPDATE_PROFILE, req.body, req)
  }
}

export default new UserService()
